Shopify.money_format = window.themeVariables.settings.moneyFormat, Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return void 0 === t ? e : t
    }

    function i(t, e, i, r) {
        if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
        var n = (t = (t / 100).toFixed(e)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = e || this.money_format;
    switch (a.match(n)[1]) {
        case "amount":
            r = i(t, 2);
            break;
        case "amount_no_decimals":
            r = i(t, 0);
            break;
        case "amount_with_comma_separator":
            r = i(t, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            r = i(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            r = i(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            r = i(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            r = i(t, 0, " ");
            break;
        case "amount_with_apostrophe_separator":
            r = i(t, 2, "'", ".")
    }
    return a.replace(n, r)
}
class ShippingMessage extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        this.render();
        console.log('render product js');
    }

    render = () => {
        // Skip client-side recalculation if server already rendered final content (e.g., preorder message)
        const template = this.innerHTML;
        if (!template.includes('[date]') && !template.includes('[remaining]')) {
            return;
        }
        const { today: serverTimeString, shippingTime } = this.dataset;
        const serverTime = this.parseServerTime(serverTimeString);

        if (!serverTime) {
            console.error("Invalid server time format.");
            this.innerHTML = `<p>Error: Invalid server time format.</p>`;
            return;
        }

        const midnight = new Date(serverTime.year, serverTime.month - 1, serverTime.day, 23, 59, 59, 999);

        const remainingMilliseconds = midnight - serverTime.dateObject;

        const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60)); // Hours
        const minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60)); // Minutes

        const remainingFormatted = `${hours}h ${minutes}min`;

        const shippingDays = parseInt(shippingTime, 10) || 0;
        const expectedDate = this.calculateExpectedShippingDate(serverTime.dateObject, shippingDays);

        const updatedMessage = template
           .replace('[date]', `<b>${expectedDate}</b>`)
            .replace('[remaining]', `<b>${remainingFormatted}</b>`);

        this.innerHTML = updatedMessage;
    }

    calculateExpectedShippingDate = (startDate, daysToAdd) => {
        let daysAdded = 0;
        let currentDate = new Date(startDate);

        while (daysAdded < daysToAdd) {
            currentDate.setDate(currentDate.getDate() + 1);

            if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
            daysAdded++;
            }
        }

        const options = { month: 'short', day: 'numeric' };
        return currentDate.toLocaleDateString('en-US', options);
        }

        parseServerTime = (timeString) => {
        const dateParts = timeString.match(/(\d+)-(\d+)-(\d+) (\d+):(\d+) ([A-Z]+) ([\-\+]\d{4})/);

        if (!dateParts) {
            return null;
        }

        const year = parseInt(dateParts[1], 10);
        const month = parseInt(dateParts[2], 10);
        const day = parseInt(dateParts[3], 10);
        const hours = parseInt(dateParts[4], 10);
        const minutes = parseInt(dateParts[5], 10);

        const serverDate = new Date(year, month - 1, day, hours, minutes, 0, 0);

        return {
            year, month, day, dateObject: serverDate,
        };
    }
}

customElements.define('shipping-message', ShippingMessage);